export interface ProvenanceBrand {
  id: "provenance";
  name: string;
  consoleLabel: string;
  basePath: "" | "/app";
}

const DEFAULT_APP: ProvenanceBrand = {
  id: "provenance",
  name: "Provenance",
  consoleLabel: "Evidence review",
  basePath: "",
};

export function provenanceBrand(
  location: Pick<Location, "hostname" | "pathname"> = typeof window === "undefined"
    ? { hostname: "", pathname: "" }
    : window.location,
): ProvenanceBrand {
  return location.pathname === "/" ||
    location.pathname === "/app" ||
    location.pathname.startsWith("/app/")
    ? { ...DEFAULT_APP, basePath: "/app" }
    : DEFAULT_APP;
}

export const brand = provenanceBrand();

export function consolePath(path: string): string {
  if (!path.startsWith("/") || path.startsWith("//") || path.startsWith("/api/")) return path;
  if (!brand.basePath || path === brand.basePath || path.startsWith(`${brand.basePath}/`))
    return path;
  return `${brand.basePath}${path}`;
}

export function stripConsoleBase(pathname: string): string {
  if (!brand.basePath) return pathname;
  if (pathname === brand.basePath || pathname === `${brand.basePath}/`) return "/";
  return pathname.startsWith(`${brand.basePath}/`)
    ? pathname.slice(brand.basePath.length)
    : pathname;
}
